import { AuthenticationType, UserId } from '@portal-front-end/models';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthCookieService {
    constructor() { }

    storeAuth(authType: AuthenticationType) {
        localStorage.setItem('session', JSON.stringify(authType));
    }

    storeAccessToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    getAuth(): AuthenticationType {
        const session = localStorage.getItem('session');
        if (session) {
            return JSON.parse(localStorage.getItem('session'));
        } else {
            return null;
        }
    }

    hasSavedSession(): boolean {
        return this.getAuth() ? true : false;
    }

    deleteSession() {
        localStorage.clear();
    }

    get accessToken(): string {
        if (localStorage.getItem('accessToken')) {
            return localStorage.getItem('accessToken');
        } else {
            return null;
        }
    }

    get getUserId(): UserId {
        if (this.hasSavedSession()) {
            return this.getAuth().user_id;
        } else {
            return null;
        }
    }

    get refreshToken(): string {
        return this.getAuth().refresh_token;
    }
}
